import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import {featureInterface} from "../../../../../interfaces/featureInterface";

const LookFeatureSku = (props) => {

  const {lookFeature, fabricatorSettings, isList} = props;

  if (!lookFeature.dbFeature.sku || fabricatorSettings.hideSku) {
    return null
  }

  if (isList) {
    return (
      <span className="lm-model lm-model--small text-left">
        <span className="lm-model__text"><FormattedMessage id="look.feature.sku"/> </span>{lookFeature.dbFeature.sku}
      </span>
    )
  }

  return (
    <span className="lm-model">
      <FormattedMessage id="look.feature.sku"/> {lookFeature.dbFeature.sku}
    </span>
  )
};

LookFeatureSku.propTypes = {
  lookFeature: PropTypes.shape(featureInterface),
  isList: PropTypes.bool,
}

const mapStateToProps = (store) => {
  const {settings} = store.fabricatorState;
  return {
    fabricatorSettings: settings,
  };
};

export default connect(mapStateToProps)(LookFeatureSku)
